import axios from "axios"
import * as env from "../constants/env"
import { utils } from "../helpers"


/* All — the studios and the operators only narrow down what the token already allows */
export const all = ({ operators = "", studios = "", start = "", end = "", testers = false, vips = true }) => {

    /* Prepare Params */
    const params = new URLSearchParams({ timezone: utils.getTimezone() })

    if (operators) params.set("operators", operators)
    if (studios) params.set("studios", studios)
    if (start) params.set("start", start)
    if (end) params.set("end", end)
    params.set("testers", testers ? "1" : "0")
    if (!vips) params.set("vips", "0")

    /* Send Request */
    const uri = `${env.startpoint}dashboard/all?${params.toString()}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }

    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}


/* Breakdown — every operator of the scope, its studios and every game under them, the same filter the numbers keep */
export const breakdown = ({ operators = "", studios = "", start = "", end = "", testers = false, vips = true }) => {

    /* Prepare Params */
    const params = new URLSearchParams({ timezone: utils.getTimezone() })

    if (operators) params.set("operators", operators)
    if (studios) params.set("studios", studios)
    if (start) params.set("start", start)
    if (end) params.set("end", end)
    params.set("testers", testers ? "1" : "0")
    if (!vips) params.set("vips", "0")

    /* Send Request */
    const uri = `${env.startpoint}dashboard/breakdown?${params.toString()}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }

    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}


/* Filters Of The Section — the studios and the operators strictly inside the scope of the token */
export const filters = () => {

    const uri = `${env.startpoint}dashboard/filters`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }

    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}
